<template>
  <section class="s-strip d-print-none page-container">
    <!-- Warning -->
    <div class="alert alert-warning alert-dismissible mb-40" role="alert">
      <div class="alert__body">
        <div class="alert__aside d-none d-lg-flex">
          <LazyImage :image="{ url: '/imgs/icons/alert-warning.svg' }" />
        </div>
        <div class="alert__main" v-html="dictionary.alertWarningText"></div>
      </div>
      <button
        type="button"
        class="btn btn-clear btn-close"
        data-bs-dismiss="alert"
        aria-label="Close">
        <i class="icon-close-light"></i>
      </button>
    </div>

    <div class="row b-personal-info mb-40 flex-column-reverse flex-xl-row">
      <!-- Personal info -->
      <div class="col-xl-8 col-lg-12">
        <!-- Personal info label -->
        <div class="row d-none d-lg-flex">
          <div class="col mb-30 fs-20">
            <span class="h2 semibold">
              {{ dictionary.resumePersonalDataLabel }}
            </span>
          </div>
        </div>
        <!-- Personal info tables -->
        <div class="b-personal-info__conts mb-40">
          <dl>
            <dt>{{ dictionary.resumeNameLabel }}</dt>
            <dd>{{ name }}</dd>
          </dl>
          <dl>
            <dt>{{ dictionary.resumeEmailLabel }}</dt>
            <dd>
              <a :href="'mailto:' + email">{{ email }}</a>
            </dd>
          </dl>
          <dl>
            <dt>{{ dictionary.resumePhoneLabel }}</dt>
            <dd>
              <a :href="'tel:' + mobilePhone">{{ mobilePhone }}</a>
            </dd>
          </dl>
        </div>
        <ul class="b-qr-buttons-list mb-40">
          <li>
            <Anchor
              v-if="returnToHomeLink"
              :item="returnToHomeLink"
              class="btn btn-outline-primary btn-full-width"></Anchor>
          </li>
        </ul>
      </div>
      <!-- Vehicle resume -->
      <div class="col-xl-4">
        <FlexDriveResume
          v-if="vehiclesData"
          :item="vehiclesData"
          :show-edit-button="false" />
      </div>
    </div>
  </section>
</template>
<script>
import * as lib from './../../lib/lib'
import LazyImage from './../components/common/LazyImage.vue'
import FlexDriveResume from './../components/flexdrive/FlexVehicleResume.vue'
import Anchor from './../components/common/Anchor.vue'

export default {
  components: {
    LazyImage,
    FlexDriveResume,
    Anchor,
  },
  data() {
    return {
      name: '',
      email: '',
      mobilePhone: '',
      landPhone: '',

      customerData: null,
      vehiclesData: null,
      returnToHomeLink: null,
    }
  },
  mounted() {
    const { customerData, vehicle, returnToHomeLink } = lib.getData(
      'flexDriveBookingData'
    )

    this.vehiclesData = vehicle
    this.customerData = customerData
    this.returnToHomeLink = returnToHomeLink

    this.name = `${this.customerData.name}  ${this.customerData.surname}`
    this.email = this.customerData.email
    this.mobilePhone = `${this.customerData.mobileDialingCode}${this.customerData.mobilePhone}`

    this.$nextTick(() => {
      lib.scrollToTop()
    })
  },
}
</script>
